import React from 'react';
import { useRecoilValue } from 'recoil';
import { ShopifyCart } from '../../models/ShopifyCart.model';
import { appliedDiscountCodeState } from '../../recoil/atoms';
import { CartShippingProgress } from './CartShippingProgress';

interface Props {
  cart?: ShopifyCart;
}

export const CartSubHeader: React.FC<Props> = ({ cart }) => {
  const appliedDiscountCode = useRecoilValue(appliedDiscountCodeState);

  return (
    <React.Fragment>
      {!!appliedDiscountCode ? (
        <div style={{ backgroundColor: 'white', padding: '10px' }}>
          <b>Discount code {appliedDiscountCode} is applied.</b> This discount may not be reflected in the cart but will be visible in the checkout.
        </div>
      ) : (
        <CartShippingProgress cart={cart} />
      )}
    </React.Fragment>
  );
};

export default CartSubHeader;
